<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div style="overflow-y: auto" v-loading="isPageLoading">
    <div v-if="isC1Auth && !isC1DevLogin" class="session-expired-layout">
      Session expired
    </div>
    <table class="login-layout" v-else-if="!isLoggedIn"><!-- //NOSONAR -->
      <tr>
        <!-- <td class="login-left"><br></td> -->
        <td class="login-right">
          <!-- <div class="login-header">
            <div>
              <div class="login-app-logo" />
            </div>
          </div> -->
          <div class="login-content">
            <div class="login-header">
              <div>
                <div class="login-app-logo" />
              </div>
            </div>
            <div class="login-body" v-if="mfaState==0" v-loading="isLoading">
              <el-form ref="loginForm" :model="loginForm" :rules="loginFormRules">
              <!-- <div class="login-welcome">{{ $t('login.welcome') }}</div> -->
              <div class="login-input">
                <div v-if="isC1DevLogin">
                  <div style="margin-bottom: 10px;">
                    <el-select v-model="c1DevServerSelected" placeholder="Select" style="width: 300px;">
                      <el-option
                        v-for="server in c1DevServers"
                        :key="server"
                        :label="'Server: ' + server"
                        :value="server">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="c1DevTenatns != null" style="margin-bottom: 20px;">
                    <el-select v-model="c1DevTenantIdSelected" placeholder="Select" style="width: 300px;">
                      <el-option
                        v-for="tenant in c1DevTenatns"
                        :key="tenant.id"
                        :label="tenant.name"
                        :value="tenant.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <el-form-item prop="email">
                  <el-input v-model="loginForm.email" maxlength="50" autofocus="true" :placeholder="$t('login.username')" type="email" @keypress.enter.native="handleLogin"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="loginForm.password" maxlength="50" :placeholder="$t('login.password')" :type="passwordType" @keypress.enter.native="handleLogin">
                  </el-input>
                  <el-button :class="{'login-eye': true, 'login-eye-on': (passwordType=='text')}"  @click="togglePasswordVisibility"></el-button>
                </el-form-item>
              </div>
              <div v-if="!isC1DevLogin" class="login-info">
                <div class="login-remember">
                  <el-checkbox  v-model="isRemember">{{ $t('login.rememberMe') }}</el-checkbox>
                </div>
                <div class="forget-password">
                  <el-link type="primary" :underline="false" @click="handleForgotPassword">{{ $t('login.forgotPassword') }}</el-link>
                </div>
              </div>
              <span  class="login-button">
                <el-button class="wy-blue-button login-button" @click="handleLogin">{{ $t('button.login') }}</el-button>
              </span>
              <span v-if="!isC1DevLogin" class="login-button">
                <button v-if="userGoogleAuth" type="button" class="login-button-google" @click="handleLoginGoogle"><svg width="40" height="40"><g id="Google-Button" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="40" height="40" rx="2" style="fill: rgb(255, 255, 255);"></rect><g id="logo_googleg_48dp" transform="translate(10.5, 10.5) scale(1.1)"><path d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727  17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z" id="Shape" fill="#4285F4"></path><path d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727  3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182  C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z" id="Shape" fill="#34A853"></path><path d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9  C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182  L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727  0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z" id="Shape" fill="#FBBC05"></path><path d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455  L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0  2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727  6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z" id="Shape" fill="#EA4335"></path><path d="M0,0 L18,0 L18,18 L0,18 L0,0 Z" id="Shape"></path></g></g></svg><div class="css-vhl90e ehzgfgn1"><div class="css-f04y3h ehzgfgn2">Sign in with Google</div></div></button>
              </span>
              </el-form>
              <login-term class="login-term"/>
              <open-source-acknowledgement class="login-term open-source-acknowledgement"/>
            </div>
            <div class="login-body" v-if="mfaState>0" v-loading="isLoading">
              <div class="mfa-title">2-Step Verification</div>
              <div v-if="mfaState==1">
                <div class="mfa-desc">Let's set up your phone</div>
                <div class="mfa-desc">What phone number do you want to use?</div>
                <div class="mfa-input"><el-input v-model="mfaPhone" type="tel" :placeholder="$t('mfa.phone')"></el-input></div>
                <div  class="mfa-button"><el-button class="wy-blue-button login-button" @click="verifyPhoneNumberHandler" :disabled="!mfaPhone || mfaPhone ==''">Next</el-button></div>
              </div>
              <div v-else-if="mfaState==2">
                <div class="mfa-desc">We just sent a text message with a verification code to {{mfaPhone}}</div>
                <div class="mfa-input"><el-input v-model="mfaCode" :placeholder="$t('mfa.code')"></el-input></div>
                <div  class="mfa-button"><el-button class="wy-blue-button login-button" @click="confirmPhoneCodeHandler" :disabled="!mfaCode || mfaCode ==''">Continue</el-button></div>
              </div>
              <div v-else-if="mfaState==3">
                <div class="mfa-desc">Wait...</div>
              </div>
            </div>
            <div ref="recaptcha" />
          </div>
        </td>
      </tr>
    </table>
    <el-dialog
      :title="$t('login.resetPassword.title')"
      v-if="resetPasswordVisible"
      :visible.sync="resetPasswordVisible"
      :show-close="false"
      :closeOnClickModal="false"
      class="wys-dialog-box send-email-dialog"
      width="390px">
      <send-email-popup :controller="module" :isShowInfo="true" :email="loginForm.email"></send-email-popup>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import SendEmailPopup from '../components/user/send-email-popup';
import LoginTerm from '../components/user/login-term';
import OpenSourceAcknowledgement from '../components/user/open-source-acknowledgement';
import firebase from 'firebase/app';
import 'firebase/auth';
import {phone} from 'phone';
import WyConstants from '../library/wy-constants';

export default Vue.extend({
  name: 'login',  
  components: {
    "send-email-popup": SendEmailPopup,
    "login-term": LoginTerm,
    "open-source-acknowledgement": OpenSourceAcknowledgement
  },
  data() {
    return {
      module: this,
      localConfig: null,
      userGoogleAuth: true,

      passwordType: 'password',  // NOSONAR

      loginForm: {
        email: '',
        password: '',
        isEmailToken: false
      },
      loginFormRules: {
        email: [
          { required: true, message: this.$t('login.auth.emailRequired'), trigger: ['blur', 'change'] },
          { type: 'email', message: this.$t('login.auth.emailInvalid'), trigger: ['blur'] }
        ],
        password: [
          { required: true, message: this.$t('login.auth.passwordRequired'), trigger: 'blur' },
          { validator: async (rule, value, callback) => {
            let msg = await this.processLogin();
            if(msg) callback(msg); else callback();
          }, trigger: []}
        ]
      },

      twoWayForm: {
        code: ''
      },

      mfaUser: null,
      mfaState: 0,
      mfaPhone: null,
      mfaCode: null,
      mfaIsEnroll: false,
      mfaResolver: null,
      mfaRecaptchaVerifier: null,

      isLoading: false,
      isPageLoading: false,
      isRemember: false,
      resetPasswordVisible: false,
      isClicking: false,

      c1DevServerSelected: Vue.WyConstants.C1_DEV_SERVERS[0],
      c1DevTenantIdSelected: null,
      c1DevTenatns: null
    }
  },

  computed: {
    ...mapGetters(['isC1Auth', 'isLoggedIn']),

    confirmButtonEnabled() {
      return (this.twoWayForm.code != '');
    },

    isC1DevLogin() {
      return Vue.WyConstants.C1_DEV_LOGIN;
    },

    c1DevServers() {
      return Vue.WyConstants.C1_DEV_SERVERS;
    }
  },

  methods: {
    ...mapActions(['login', 'c1Login', 'fetchGlobalConfiguration']),

    async handleLogin() {      
      if(!this.localConfig || !this.localConfig.authConfig) {
        this.localConfig = await this.fetchGlobalConfiguration();
      }

      if(!this.isClicking) {
        this.isClicking = true;
        this.$refs.loginForm.validate(async () => {});
      }
      setTimeout(()=>{
        this.isClicking = false;
      }, 1000)
    },

    /*handleLoginGoogle() {
      if(this.localConfig && this.localConfig.authConfig && this.localConfig.authConfig.userGoogleAuth) {
        let provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithRedirect(provider);
      }
    },*/

    async handleForgotPassword() {
      if(await this.fetchGlobalConfiguration()) {
        this.resetPasswordVisible = true;
        this.$store.dispatch('amplitudeLog', {name: 'forgot_password'});
      }
      else {
        this.$root.showNotificationLocale("error", null, 'errorCode.code5002');
        setTimeout(() => {
          window.location.reload();
        }, 800)
      }
    },

    async handleLoginGoogle() {
      this.loginForm.isEmailToken = false;

      try {
        if(!this.localConfig || !this.localConfig.authConfig) {
          this.localConfig = await this.fetchGlobalConfiguration();
        }
        
        if(!this.mfaRecaptchaVerifier) {
          this.mfaRecaptchaVerifier = new firebase.auth.RecaptchaVerifier(this.$refs.recaptcha, {'size': 'invisible'});
        }

        let provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
          .then(async (firebaseRes) => {
            if(!this.mfaEnrollNeeded(firebaseRes)) {
              let firebaseToken = await firebaseRes.user.getIdToken();
              let msg = await this.doLogin({googleToken: firebaseToken});
              if(msg && msg != "") {
                this.$root.showNotification("error", null, msg);
              }
            }
          })
          .catch((error) => {
            if(!this.mfaVerifyNeeded(error)) {
              console.error(error);
              this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
              this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
            }
          });
      }
      catch(e) {
        if(e.code === "auth/argument-error") {
          this.$root.initApp();

          if(this.localConfig && this.localConfig.authConfig && this.localConfig.authConfig.firebaseConfig) {
            // Initialize Firebase
            firebase.initializeApp(this.localConfig.authConfig.firebaseConfig);
          }
        }
        else {
          console.error(e);
        }
      }
    },

    async processLogin() {
      let msg = null;

      if(this.mfaState == 0 && this.loginForm.email != '' && this.loginForm.password != '') {
        this.isLoading = true;
        this.loginForm.isEmailToken = true;

        let params = {email: this.loginForm.email, password: this.loginForm.password};
        // remember the username
        if(this.isRemember === true) {
          Vue.localStorage.set('loginUsername', this.loginForm.email);
        }
        else {
          Vue.localStorage.remove('loginUsername');
        }
        
        try {
          if(this.isC1DevLogin) {
            msg = await this.doC1Login(params);
          }
          else if(this.userGoogleAuth) {
            if(!this.mfaRecaptchaVerifier) {
              try {
                this.mfaRecaptchaVerifier = new firebase.auth.RecaptchaVerifier(this.$refs.recaptcha, {'size': 'invisible'});
              }
              catch(e) {                
                this.isLoading = false;
                if(e.code === "auth/argument-error") {
                  this.$root.initApp();
                }
                else {
                  console.error(e);
                }
              }
            }

            let firebaseRes = await firebase.auth().signInWithEmailAndPassword(params.email, params.password);
            if(!this.mfaEnrollNeeded(firebaseRes)) {
              let firebaseToken = await firebaseRes.user.getIdToken();
              msg = await this.doLogin({googleToken: firebaseToken});
            }
          }
          else {
            msg = await this.doLogin(params);
          }
        }
        catch(error) {
          if(!this.mfaVerifyNeeded(error)) {
            this.isLoading = false;
            console.error(error);
            this.$root.showNotificationLocale("error", null, 'login.auth.incorrectInput');
            this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
          }
        }        
      }
      return msg;
    },

    async doLogin(param) {
      let msg = null;

      if(param) {
        param.isEmailToken = this.loginForm.isEmailToken;

        try {
          let res = await this.login(param);
          if(res && res.status == 200 && res.data.token) {
            this.$store.dispatch('amplitudeLog', {name: 'customer_login'});
            this.$router.push({path: '/default'});
          }
          else if(res.data && res.data.errorCode == 1005) {
            this.$router.push({name: 'changePassword', params: {email: this.loginForm.email, code: res.data.errorCode, message: this.$t(`errorCode.code${res.data.errorCode}`)}});
          }
          else if(res.data && res.data.errorCode == 2001) {
            this.$router.push({name: 'changePassword', params: {email: this.loginForm.email, code: res.data.errorCode}});
          }
          else if(res.data && res.data.errorCode) {
            msg = this.$t(`errorCode.code${res.data.errorCode}`);
          }
          else {
            msg = this.$t('login.auth.incorrectInput');
            this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
          }
        }
        catch(e) {
          if(e.code && e.code.indexOf("auth/" > -1)) {
            let errorCode = e.code.replace("auth/", "");
            msg = this.$t(`login.auth.${errorCode}`);
          }

          if(!msg || msg == "") {
            msg = this.$t('login.auth.incorrectInput');
          }
          this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
        }
        finally {
          this.isLoading = false;
        }
      }

      return msg;
    },

    async doC1Login(param) {
      let msg = null;

      if(param) {
        try {
          param.authHost = this.c1DevServerSelected;
          param.authOptions = null;
          param.authUrl = window.location.href;
          param.productName = WyConstants.C1_DEV_MODE;
          param.tenantId = this.c1DevTenantIdSelected;
          
          const res = await this.c1Login(param);
          if(res && res.status === 409) {
            try {
              const tenants = JSON.parse(res.data.errorMessage);
              if(tenants && tenants.length > 0) {
                tenants.sort((a, b) => a.name.localeCompare(b.name));
                this.c1DevTenatns = tenants;
              }
            }
            catch(e) {
              msg = res.data.errorMessage
            }
          }
        }
        catch(e) {
          if(e.code && e.code.indexOf("auth/" > -1)) {
            let errorCode = e.code.replace("auth/", "");
            msg = this.$t(`login.auth.${errorCode}`);
          }

          if(!msg || msg == "") {
            msg = this.$t('login.auth.incorrectInput');
          }
          this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
        }
        finally {
          this.isLoading = false;
        }
      }

      return msg;
    },

    togglePasswordVisibility() {
      this.passwordType = (this.passwordType == 'password') ? 'text' : 'password';
    },

    resetRecaptchaVerifier() {
      if(this.mfaRecaptchaVerifier) {
        this.mfaRecaptchaVerifier.reset(this.$refs.recaptcha);
      }
      return this.mfaRecaptchaVerifier;
    },

    mfaEnrollNeeded(firebaseRes) {
      if(this.localConfig.authConfig.useMFA && firebaseRes && (!firebaseRes.user.multiFactor.enrolledFactors || firebaseRes.user.multiFactor.enrolledFactors.length == 0)) {
        // ask user and provide UI to enroll MFA
        this.mfaState = 1;
        this.mfaUser = firebaseRes.user;
        this.mfaIsEnroll = true;
        this.isLoading = false;
        return true;
      }
      return false;
    },

    async mfaVerifyNeeded(error) {
      if(error.code && error.code.indexOf("auth/") == 0) {
        if (error.code == 'auth/multi-factor-auth-required') {        
          let resolver = error.resolver;
          let phoneInfoOptions = {
            multiFactorHint: resolver.hints[0],
            session: resolver.session
          };
          
          let phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
          // Send SMS verification code
          phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, this.resetRecaptchaVerifier())
            .then((verificationId) => {
              this.isLoading = false;
              // ask user to enter the code
              this.mfaResolver = resolver;
              this.mfaVerificationId = verificationId;
              this.mfaPhone = phoneInfoOptions.multiFactorHint ? phoneInfoOptions.multiFactorHint.phoneNumber : "";
              this.mfaState = 2;              
            })
            .catch((error) => {
              this.isLoading = false;
              console.error(error)
              this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
            })

          return true;
        }
        else {
          this.isLoading = false;
          this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
        }
      }          
      return false;
    },

    verifyPhoneNumberHandler() {
      let phoneResult = phone(this.mfaPhone);
      
      if(phoneResult.isValid) {
        this.isLoading = true;
        this.mfaPhone = phoneResult.phoneNumber;

        this.mfaUser.multiFactor.getSession()
          .then((multiFactorSession) => {            
            // Specify the phone number and pass the MFA session.
            let phoneInfoOptions = {
              phoneNumber: this.mfaPhone,
              session: multiFactorSession
            };
            
            let authProvider = new firebase.auth.PhoneAuthProvider();
            return authProvider.verifyPhoneNumber(phoneInfoOptions, this.resetRecaptchaVerifier());
          })
          .then((verificationId) => {
            this.isLoading = false;
            // Ask user for the verification code.
            this.mfaVerificationId = verificationId;
            this.mfaState = 2;
          })
          .catch((error) => {
            console.error(error)
            this.isLoading = false;
            this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
          })
      }
      else {        
        setTimeout(() => {
          this.$root.showNotificationLocale("error", null, `mfa.auth/phone`, {duration: 8000});
        }, 500)
      }
    },

    async confirmPhoneCodeHandler() {
      this.isLoading = true;
      
      try {
        // verify text SMS code
        let credential = firebase.auth.PhoneAuthProvider.credential(this.mfaVerificationId, this.mfaCode);
        let multiFactorAssertion = firebase.auth.PhoneMultiFactorGenerator.assertion(credential);

        if(this.mfaIsEnroll) {
          // user has not enrolled 2F
          this.mfaUser.multiFactor.enroll(multiFactorAssertion, "Text")
            .then(async () => {
              this.mfaState = 3;
              this.mfaPhone = null;
              // after enrollled, process access service login using the new token
              let firebaseToken = await this.mfaUser.getIdToken();
              let msg = await this.doLogin({googleToken: firebaseToken});              
              if(msg && msg != "") {
                this.$root.showNotification("error", null, msg);
              }
            })
            .catch((error) => {
              console.error(error)
              if(error.code == "auth/code-expired") {
                this.mfaCode = '';
                this.mfaState = 0;
              }
              this.isLoading = false;
              this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
            })
        }
        else {
          // user has enrolled 2F
          await this.mfaResolver.resolveSignIn(multiFactorAssertion)
            .then(async (userCredential) => {
              this.mfaState = 3;
              this.mfaPhone = null;
              // after verified the code, process access service login using the new token
              let firebaseToken = await userCredential.user.getIdToken();
              let msg = await this.doLogin({googleToken: firebaseToken});
              if(msg && msg != "") {
                this.$root.showNotification("error", null, msg);
              }
            })
            .catch((error) => {
              console.error(error)
              if(error.code == "auth/code-expired") {
                this.mfaCode = '';
                this.mfaState = 0;
              }
              this.isLoading = false;
              this.$root.showNotificationLocale("error", null, `mfa.${error.code}`, {duration: 8000, defVal: error.message});
            })
        }
      }
      catch(error) {
        console.error(error);
        this.isLoading = false;
        this.$root.showNotification("error", null, error.message, {duration: 8000});
        this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
      }
    }
  },

  mounted() {
    this.$store.dispatch('amplitudeLog', {name: 'login_page_loaded'});
  },

  async created() {
    if(this.$store.getters.isLoggedIn) {
      this.$router.push({ path: "/default" })
    }
    else {
      this.$store.dispatch('resetAuth');

      let rememberUsername = Vue.localStorage.get('loginUsername');
      if(rememberUsername) {
        this.loginForm.email = rememberUsername;
        this.isRemember = true;
      }
    }

    /*let authConfig = this.localConfig.authConfig;
    if(authConfig && authConfig.firebaseConfig) {
      firebase.auth().getRedirectResult()
        .then(async (result) => {
          this.isPageLoading = true;
          if(result.user) {
            let firebaseToken = await result.user.getIdToken();
            let res = await this.login({googleToken: firebaseToken});
            
            if(res && res.status == 200 && res.data.token) {
              this.$store.dispatch('amplitudeLog', {name: 'customer_login'});
              this.$router.push({path: '/default'});
            }
            else {
              this.$root.showNotificationLocale("error", null, 'login.auth.incorrectInput');
              this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
            }
          }
          this.isPageLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$root.showNotificationLocale("error", null, 'login.auth.incorrectInput');
          this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
        });
    }*/
  }
});
</script>

<style lang="scss">
.wy-login-page {
  .login-layout {
    min-height: 745px;
  }

  .session-expired-layout {
    padding: 40px;
    text-align: center;
  }
  
  background-color: var(--login-page-background-color);
  background-image: var(--login-page-background-image) !important;
  // background-size: 730px 1408px;
  // background-repeat: no-repeat;
  // // background-position-x: 1145px;
  // // background-position-y: -223px;
  // background-position-x: 108%;
  // background-position-y: 49.1%;

  background-size: 42% 130%;
  background-repeat: no-repeat;
  // background-position-x: 1145px;
  // background-position-y: -223px;
  background-position-x: 108%;
  background-position-y: 49.1%;

  .login-content {
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: flex-start;
    padding: 40px;
    width: 380.48px !important;
    height: 423px;
    left: calc(50% - 229px);
    position: inherit;
    // top: calc(50% - 500px);
  }

  .login-body {
    // -webkit-box-shadow: -6px 0px 20px #1d1541;
    // box-shadow: -6px 0px 20px #1d1541;
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    border-radius: 5px;
    background: #FFFFFF;
    padding: 40px 40px;
    margin-top: 70px;
    width: 300px;
    
    .mfa-title {
      color: #214586;
      font-size: 26px;
      margin-bottom: 5px;
    }
    .mfa-desc {
      margin-bottom: 5px;
    }
    .mfa-input {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .mfa-button {
      text-align: right;
    }
    .el-form {
      height: 257px;
    }
  }

  .login-app-logo {
    width: 330px !important;
    height: 85px !important;
    background-image: var(--header-logo);
    background-size: 330px 77px;
    background-repeat: no-repeat;
  }

  .login-left.chatanalytics {
    background-image: url('../assets/images/welcome_image_v2.png') !important;
  }

  .login-app-logo.chatanalytics {
    width: 400px !important;
    height: 80px !important;
    background-image: url('../assets/images/va_chatanalytics.png') !important;
    background-size: 80%;
    background-position-y: 0px;
    background-position-x: 5px;
    background-repeat: no-repeat;
    padding-left: 96px;
  }

  .login-header {
    position: relative;
    left: calc(50% - 166px);
    top: -20px;
  }

  .login-welcome {
    margin-top: 30px;
    font-size: 17px;
    font-weight: 500;
  }

  .login-input {
    text-align: left;
    // margin-top: 34px;
    .el-input__inner {
      font-size: 15px;
      border-width: 1px !important;
      border-radius: 0;
      height: 45px;
      padding-left: 15px;
      padding-right: 15px;
    }
    .login-eye {
      background-image: url("../assets/images/login_eye.svg");
      background-position-x: 0px;
      background-position-y: 3px;
      background-repeat: no-repeat;
      padding: 10px 10px 10px 10px;
      margin: 0px;
      background-color: transparent;
      border: 0;
      position: relative;
      left: 270px;
      top: -49px;
    }
    .login-eye.login-eye-on {
      background-image: url("../assets/images/login_eye_on.svg");
    }
    .el-form-item {
      margin-bottom: 20px;
      height: 45px;

      .el-form-item__content {
        position: relative;
        font-size: 14px;

        .el-form-item__error {
          position: absolute;
          top: 47px;
          background-position-y: 0px;
          background-size: 13px;
          padding-top: 0px;
        }
      }
    }
  }
  
  .login-info {
    min-height: 30px;
    padding-bottom: 15px;
    padding-top: 0px;
    .login-remember {
      display: none;
      float: left;
      .el-checkbox__label {
        font-size: 14px;
        color: var(--site-font-drop-down-primary-color);
        font-weight: 500;
        line-height: 21px;
      }
    }
    .forget-password {
      float: right;
      margin-top: 8px;
      .el-link.el-link--primary {
        font-size: 12px;
        color: #214586;
        font-weight: 400;
      }
      .el-link.el-link--primary:hover {
        color: #214586;
        font-weight: 400;
      }
    }
  }

  .login-button {
    width: 100%;
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 500;
    line-height: 28px;
  }

  .login-term {
    margin-top: 75px;
    font-size: 12px !important;
    font-weight: 400;
    .wy-login-term-link {
      color: #214586 !important;
    }
    .wy-login-term-link:hover {
      color: #214586 !important;
    }
  }
  .login-term.open-source-acknowledgement {
    margin-top: 10px;
  }

  .codeForm {
    .details {
      margin-top: 7px;
    }
  }

  .login-button-google {
    // float: right;
    display: flex;
    flex-direction: row;
    padding: 0px 2px 0px 0px;
    border: 1px solid #DCDFE6;
    border-radius: 30px;
    width: -moz-available;
    width: -webkit-fill-available;
    // width: 273px;
    box-sizing: content-box;
    cursor: pointer;
    background-color: #FFF;
    padding-left: 23px;
    line-height: 100%;

    svg {
      padding-left: 28px;
      width: 62px;
      height: 50px;
      rect {
        width: 50px;
        height: 50px;
      }
      g {
        transform: translate(8.5px, 4.5px) scale(1.3, 1.3) !important;
      }
    }

    .css-vhl90e {
      -webkit-box-flex: 1;
      // flex-grow: 1;
      height: 50px;
    }

    .css-f04y3h {
      // color: rgb(255, 255, 255);
      font-size: 14px;
      font-weight: 500;
      line-height: 50px;
      height: 50px;
    }
  }
}

// @media screen and (max-width: 1500px) {
//   .wy-login-page {
//     .login-layout {
//       min-height: 505px;
//     }
//     .login-content {
//       padding: 40px;
//       position: absolute;
//       width: 380.48px !important;
//       height: 423px;
//       left: calc(50% - 229px);
//       position: inherit;
//     }

//     .login-body {
//       -webkit-box-shadow: -6px 0px 20px #1d1541;
//       box-shadow: -6px 0px 20px #1d1541;
//       border-radius: 5px;
//       background: #FFFFFF;
//       padding: 40px 40px;
//       margin-top: 7px;
//       width: 224px;
//       height: 240px;
      
//       .mfa-title {
//         color: #214586;
//         font-size: 26px;
//         margin-bottom: 5px;
//       }
//       .mfa-desc {
//         margin-bottom: 5px;
//       }
//       .mfa-input {
//         margin-top: 10px;
//         margin-bottom: 20px;
//       }
//       .mfa-button {
//         text-align: right;
//       }
//       .el-form {
//         height: 175px;
//       }
//     }

//     .login-app-logo {
//       width: 310px !important;
//       height: 65px !important;
//       background-image: var(--header-logo);
//       background-size: 310px 65px;
//       background-repeat: no-repeat;
//     }

//     .login-left.chatanalytics {
//       background-image: url('../assets/images/welcome_image_v2.png') !important;
//     }

//     .login-app-logo.chatanalytics {
//       width: 400px !important;
//       height: 80px !important;
//       background-image: url('../assets/images/va_chatanalytics.png') !important;
//       background-size: 80%;
//       background-position-y: 0px;
//       background-position-x: 5px;
//       background-repeat: no-repeat;
//       padding-left: 96px;
//     }

//     .login-header {
//       position: relative;
//       left: calc(50% - 195px);
//       top: -70px;
//     }

//     .login-welcome {
//       margin-top: 30px;
//       font-size: 17px;
//       font-weight: 500;
//     }

//     .login-input {
//       text-align: left;
//       // margin-top: 34px;
//       .el-input__inner {
//         font-size: 12px;
//         border-width: 1px !important;
//         border-radius: 0;
//         padding-left: 5px;
//         height: 36px;
//         padding-left: 15px;
//         padding-right: 15px;
//       }
//       .login-eye {
//         background-image: url("../assets/images/login_eye.svg");
//         background-position-x: 0px;
//         background-position-y: 3px;
//         background-repeat: no-repeat;
//         padding: 10px 10px 10px 10px;
//         margin: 0px;
//         background-color: transparent;
//         border: 0;
//         position: relative;
//         left: 198px;
//         top: -42px;
//       }
//       .el-form-item {
//         margin-bottom: 5px;
//         height: 45px;

//         .el-form-item__content {
//           position: relative;
//           font-size: 12px;

//           .el-form-item__error {
//             position: absolute;
//             top: 41px;
//             background-position-x: 7px;
//             background-position-y: 0px;
//             background-size: 10px;
//             padding-top: 0px;
//             line-height: 11px;
//             font-size: 9px;
//           }
//         }
//       }
//       // .el-form-item.is-error .el-input__inner:focus {
//       //   border-bottom-width: 1px !important;
//       // }
//     }
    
//     .login-info {
//       min-height: 30px;
//       padding-bottom: 0px;
//       padding-top: 0px;
//       .login-remember {
//         display: none;
//         float: left;
//         .el-checkbox__label {
//           font-size: 14px;
//           color: var(--site-font-drop-down-primary-color);
//           font-weight: 500;
//           line-height: 21px;
//         }
//       }
//       .forget-password {
//         float: right;
//         margin-top: 0px;
//         .el-link.el-link--primary {
//           font-size: 10px;
//           color: #214586;
//           font-weight: 400;
//         }
//         .el-link.el-link--primary:hover {
//           color: #214586;
//           font-weight: 400;
//         }
//       }
//     }

//     .login-button {
//       font-size: 12px;
//       margin-bottom: 5px;
//       line-height: 100%;
//     }

//     .login-term {
//       margin-top: 75px;
//       font-size: 9px !important;
//       font-weight: 400;
//       .wy-login-term-link {
//         color: #214586 !important;
//       }
//       .wy-login-term-link:hover {
//         color: #214586 !important;
//       }
//     }

//     .codeForm {
//       .details {
//         margin-top: 7px;
//       }
//     }

//     .login-button-google {
//       // float: right;
//       display: flex;
//       font-size: 12px;
//       padding-left: 20px;
//       line-height: 34px;

//       svg {
//         padding-left: 20px;
//         width: 30px;
//         height: 34px;
//         rect {
//           width: 32px;
//           height: 30px;
//         }
//         g {
//           transform: translate(3.5px, 4px) scale(1, 1) !important;
//         }
//       }

//       .css-vhl90e {
//         -webkit-box-flex: 1;
//         // flex-grow: 1;
//         height: 23px;
//       }

//       .css-f04y3h {
//         // color: rgb(255, 255, 255);
//         font-size: 12px;
//         font-weight: 500;
//         line-height: 34px;
//         height: 34px;
//       }
//     }
//   }
// }
</style>